module.exports = __webpack_public_path__ + "weathericons-regular-webfont.8cac70ebda3f23ce4721.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/weathericons-regular-webfont.woff
// module id = 1437
// module chunks = 2